/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { iccidState, releaseESIMLocal } from '../../../helpers/iccidStatus';

type IccidPoolsChangeStatusType = {
    iccid: PlatformIccidPoolNumber;
    open: boolean;
    reload(): void;
    close(): void;
    eSim?: boolean;
};

export const IccidPoolsChangeStatus: FunctionComponent<IccidPoolsChangeStatusType> = ({ open, close, iccid, reload, eSim }): ReactElement => {
    const dispatch = useDispatch();
    const [currentStatus, setCurrentStatus] = useState<number>(iccid.iccidState);

    useEffect(() => {
        if (open) {
            setCurrentStatus(iccid.iccidState);
        }
    }, [open, iccid]);

    const setNewStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setCurrentStatus(parseInt(String(event.target.value)));
    };

    const changeStatus = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        if (currentStatus === iccidState.ARCHIVE) {
            iccid.deleted = true;
            iccid.archivingDate = DateHelperTs.getCurrentDateTime();
        }
        if (currentStatus !== iccidState.ARCHIVE && iccid.deleted) {
            iccid.deleted = false;
            iccid.archivingDate = null;
        }
        iccid.iccidState = eSim ? releaseESIMLocal : iccidState.FREE;
        itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(iccid['@id']),
            'update-status-time-iccid',
            iccid,
            (data: PlatformIccidPoolNumber): void => {
                reload();
                close();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <Dialog fullWidth={true} maxWidth="sm" open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                {!eSim && <I18n trans="pools:sim.change_status" />}
                {eSim && <I18n trans="pools:sim.local_release_e_sim" />}
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        {!eSim && <I18n trans="pools:sim.change_status_to_free" />}
                        {eSim && <I18n trans="pools:sim.eSIM_change_status_to_free" />}
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={close} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={changeStatus} callbackParam={{}} label="general:common.ok" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
